import { render, staticRenderFns } from "./choseAll.vue?vue&type=template&id=a4db6f84&scoped=true&"
import script from "./choseAll.vue?vue&type=script&lang=ts&"
export * from "./choseAll.vue?vue&type=script&lang=ts&"
import style1 from "./choseAll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4db6f84",
  null
  
)

export default component.exports